import { useEffect, useState } from "react";
import { getConfig } from "./api";
import type { VaultConfig } from "./types";

export function useConfig() {
  const [config, setConfig] = useState<VaultConfig | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    void getConfig()
      .then((value) => {
        if (active) setConfig(value);
      })
      .catch((configError) => {
        if (!active) return;
        setError(configError instanceof Error ? configError : new Error("Backend configuration failed."));
      });
    return () => {
      active = false;
    };
  }, []);

  if (error) throw error;

  return config;
}
